// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import React from "react";

enum fields {
    showPrintOnly = "showPrintOnly",
}

interface RfqQuoteDetailsActions extends WidgetProps {
    fields: {
        [fields.showPrintOnly]: boolean;
    };
}

const RfqQuoteDetailsTotal = ({ fields: { showPrintOnly } }: RfqQuoteDetailsActions) => {
    return (
        <>
            {createWidgetElement("RfqQuoteDetails/RfqQuoteDetailsHeader", {
                showActionsOnly: true,
                showPrintOnly,
                fields: {},
            } as any)}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: RfqQuoteDetailsTotal,
    definition: {
        displayName: "Actions",
        allowedContexts: ["RfqQuoteDetailsPage"],
        group: "RFQ Quote Details",
        // XNG-Changes
        fieldDefinitions: [
            {
                name: fields.showPrintOnly,
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
